module.exports = __webpack_public_path__ + "static/media/quickbooks_icon.3e198408.svg";